import React from 'react';

// Icons File
import Icons from '../icons';

const SelectInput = ({ solClass=" ", heading, className, options, selectedValue, error, errorMeg, onChange, value = null, defaultOption = null, sglIcon }) => {
  return (
    <>
        {heading && <div className={`sgr-outer-label ${solClass}`}>{heading}</div>}
        <div className={`signinup-group ${className} ${error ? "error-group" : ""}`}>
            <select value={value} onChange={onChange}>
              {defaultOption && 
                 <option key={0} value={''}>
                 {defaultOption}
                 </option>
              }
            {options && options.map((option, index) => (
                <option key={index} value={option.value} disabled={option.disabled}>
                {option.name}
                </option>
            ))}
            </select>
            <div className='group_right_icon gri-select-icon'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
  <path fillRule="evenodd" d="M12.53 16.28a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 14.69l6.97-6.97a.75.75 0 1 1 1.06 1.06l-7.5 7.5Z" clipRule="evenodd" />
</svg>
</div>
            {sglIcon && <div className='group_left_icon'>{sglIcon}</div> }
            {(error && errorMeg && <span className="form-error-msg">{errorMeg}</span>)}
        </div>
    </>
  );
};

export default SelectInput;
